import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers: (number | string)[] = [];
  const maxPageNumbersToShow = 5; // Adjust as needed

  // for (let i = 1; i <= totalPages; i++) {
  //   pageNumbers.push(i);
  // }

  if (totalPages <= maxPageNumbersToShow) {
    // If total pages are less than or equal to the max limit, show all pages
    for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
    }
} else {
    // Always show first and last pages
    pageNumbers.push(1);
    
    let startPage = Math.max(2, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);
    
    if (startPage > 2) {
        pageNumbers.push("...");
    }
    
    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    if (endPage < totalPages - 1) {
        pageNumbers.push("...");
    }
    
    pageNumbers.push(totalPages);
}
 
  return (
 
  <nav aria-label="Blog Pagination">
    <ul className="pagination style-1">
        {/* Previous Button */}
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                Prev
            </button>
        </li>

        {/* Page Numbers */}
        {pageNumbers.map((number, index) =>
            number === "..." ? (
                <li key={index} className="page-item disabled">
                    <span className="page-link">...</span>
                </li>
            ) : (
                <li key={number} className={`page-item ${number === currentPage ? "active" : ""}`}>
                    <button className={"page-link " + (number === currentPage ? "active" : "")} onClick={() => onPageChange(number)}>
                        {number}
                    </button>
                </li>
            )
            
        )}

        {/* Next Button */}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                Next
            </button>
        </li>
    </ul>
  </nav> 
  );
};

export default Pagination;